import { IonButton, IonCol, IonRow } from '@ionic/react';
import React from 'react';
import { Link } from 'react-router-dom';
import { Card, CardActionArea, CardMedia, Tabs } from '@material-ui/core';
import { ALLOW_CASINO } from '../../constants/CasinoPermission';
import { DcGameNew } from '../../models/dc/DcGame';

interface GameCardListProps {
  getRoyalGamingUrl: (
    gameId: string,
    gameName: string,
    gameCode: string,
    provider: string,
    subProvider: string
  ) => Promise<void>;
  gameList: DcGameNew[];
  heading: string;
  redirectTo?: string;
  subprovider : string;
}

const GameCardsList: React.FC<GameCardListProps> = ({
  heading,
  getRoyalGamingUrl,
  gameList,
  redirectTo,
  subprovider
}) => {
  return (
    <IonRow class="live-games">
      <IonCol size="12" className="live-games-header">
        <div>
          <div className="live-games-text">{heading}</div>
          <div className="text-border-btm"></div>
        </div>
        {ALLOW_CASINO ? (
          <Link className="more-link" to={redirectTo || '/casino?subprovider='+subprovider}>
            <IonButton color="primary" size="small" className="browse-all-btn">
              Browse All
            </IonButton>
          </Link>
        ) : (
          <IonButton color="primary" className="browse-all-btn">
            Browse All
          </IonButton>
        )}
      </IonCol>

      {/* Live Casino */}
      <div>
        <div
          className="gametypes-tabs web-view"
          style={{
            display: 'flex',
            overflowX: 'auto',
            gap: '15px',
            padding: '20px',
            borderRadius: '80px',
          }}
        >
          <div
            className="gametypes-tabs web-view"
            style={{
              display: 'flex',
              overflowX: 'scroll',
              WebkitOverflowScrolling: 'touch',
              scrollbarWidth: 'none',
              msOverflowStyle: 'none',
              borderRadius: '10px',
              gap: '10px',
              scrollBehavior: 'smooth',
            }}
          >
            {gameList?.map((game, idx) => (
              <div
                key={game.gameName}
                className="live-game"
                style={{
                  flex: '0 0 auto',
                  width: 'auto',
                }}
              >
                <div
                  className="dc-ion-card"
                  onClick={() => {
                    if (ALLOW_CASINO) {
                      getRoyalGamingUrl(
                        game.gameId,
                        game.gameName,
                        game.gameCode,
                        game.providerName,
                        game.subProviderName
                      );
                    }
                  }}
                  style={{
                    cursor: 'pointer',
                    borderRadius: '10px',
                    overflow: 'hidden',
                  }}
                >
                  <div className="card-action-area">
                    <img
                      alt={game.gameName}
                      className="dc-card-media tv-games-img"
                      src={game.urlThumb ? game.urlThumb : ''}
                      title={game.gameName}
                      style={{
                        width: '220px',
                        height: '180px',
                        display: 'block',
                        borderRadius: '10px',
                        objectFit: 'fill',
                      }}
                    />
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>


      <IonRow className="mob-view">
        {gameList.map((game, idx) => (
          <>
            {idx < 6 ? (
              <IonCol
                sizeXs="4"
                sizeSm="4"
                sizeMd="3"
                sizeLg="3"
                class="live-game tv-game"
                key={game.gameName}
              >
                <Card
                  key={'incasino-game-' + idx}
                  className="dc-ion-card"
                  onClick={() => {
                    if (ALLOW_CASINO)
                      getRoyalGamingUrl(
                        game.gameId,
                        game.gameName,
                        game.gameCode,
                        game.providerName,
                        game.subProviderName
                      );
                  }}
                >
                  <CardActionArea>
                    <CardMedia
                      component="img"
                      alt={game.gameName}
                      className="dc-card-media"
                      image={game.urlThumb ? game.urlThumb : ''}
                      title={game.gameName}
                    />
                    {/* <CardContent className="dc-card-ctn">
                    <Typography gutterBottom className="game-name">
                      {game.text}
                    </Typography>
                  </CardContent> */}
                  </CardActionArea>
                </Card>
              </IonCol>
            ) : null}
          </>
        ))}
      </IonRow>
    </IonRow>
  );
};

export default GameCardsList;